import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_SLA_ASSIGNEE, GET_SLA_ASSIGNEE_SUCCESS, GET_SLA_ASSIGNEE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSlaAssignee({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/sla-assignees`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SLA_ASSIGNEE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SLA_ASSIGNEE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SLA_ASSIGNEE_ERROR, payload: error });
  }
}

export function* watchGetSlaAssignee() {
  yield takeEvery(GET_SLA_ASSIGNEE, getSlaAssignee);
}

function* getSlaAssigneeSaga() {
  yield all([fork(watchGetSlaAssignee)]);
}

export default getSlaAssigneeSaga;